export {
  clearStaticDatabaseConnectionMemo,
  createStaticDatabaseConnection,
  getOnlineStaticDatabase,
  getStaticDatabase,
  type StaticDatabase,
  type StaticDatabaseConnection,
  type StaticDatabaseHandle,
} from "#static-database";
